import { useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useQuests } from '../context/QuestContext';
import { useCharacterOptional } from '../context/CharacterContext';
import { usePopupMessage } from '../hooks/usePopupMessage';
import { tl } from './inlineI18n';

// Görevden hedefe git: konuşma/teslim → köydeki NPC; öldür/düşür/kes → savaşta canavarın çıktığı nokta.
export const useQuestNavigator = () => {
  const navigate = useNavigate();
  const quests = useQuests();
  const character = useCharacterOptional();
  const { setError, setStatus } = usePopupMessage();
  const currentVillageId = character?.userCharacter?.villageId ?? character?.character?.villageId ?? null;

  const goToNpc = useCallback(({ npc, villageId }) => {
    if (!npc) return;
    if (villageId && currentVillageId && Number(villageId) !== Number(currentVillageId)) {
      setError?.(tl(`${npc} başka bir köyde. Önce oraya yolculuk et.`, `${npc} is in another village. Travel there first.`));
      quests?.closeQuests?.();
      navigate('/travel');
      return;
    }
    quests?.closeQuests?.();
    navigate('/village', { state: { openNpc: npc, villageId } });
  }, [currentVillageId, navigate, quests, setError]);

  const goHunt = useCallback(async ({ monsterId, monster }) => {
    try {
      const res = await axios.get('/api/quest-target', { params: { monsterId: monsterId || undefined, monster: monster || undefined } });
      const d = res.data;
      if (!d?.success) {
        setError?.(d?.message || tl('Canavarın yeri bulunamadı.', 'Monster location not found.'));
        return;
      }
      quests?.closeQuests?.();
      if (currentVillageId && d.villageId && Number(d.villageId) !== Number(currentVillageId)) {
        setError?.(tl(`${d.name} ${d.villageName || 'başka bir köy'}de çıkar. Önce oraya yolculuk et.`, `${d.name} appears in ${d.villageName || 'another village'}. Travel there first.`));
        navigate('/travel');
        return;
      }
      setStatus?.(tl(`${d.name} avına gidiyorsun.`, `Heading out to hunt ${d.name}.`));
      navigate('/battle', { state: { questTarget: { x: d.x, y: d.y, name: d.name, at: Date.now() } } });
    } catch (err) {
      setError?.(err.response?.data?.message || err.message);
    }
  }, [currentVillageId, navigate, quests, setError, setStatus]);

  return { goToNpc, goHunt };
};

export default useQuestNavigator;
